import Swiper from "swiper/bundle";

export const subscriptionPopular = () => {
    const $subscriptionPolular = document.querySelector(
        ".section-subscription-popular"
    );
    
    if ($subscriptionPolular) {
        const $subscriptionPopularWrapper = $subscriptionPolular.querySelector(
            ".subscription-popular__wrapper"
        );

        const $wrapperInfo =
            $subscriptionPopularWrapper?.querySelector(".wrapper__info");

        const $infoNav = $wrapperInfo?.querySelector(".info__nav");
        const $navLeft = $infoNav?.querySelector(".nav__left");
        const $navRight = $infoNav?.querySelector(".nav__right");

        const $wrapperSwiper = $subscriptionPopularWrapper.querySelector(
            ".wrapper__swiper.swiper"
        );
        if ($wrapperSwiper) {
            const swiperConfig = {
                direction: "horizontal",
                speed: 1000,
                slidesPerView: 1.2,
                slidesPerGroup: 1,
                spaceBetween: 12,
                breakpoints: {
                    768: {
                        slidesPerView: 2.4,
                        slidesPerGroup: 1,
                        slidesPerGroupAuto: true,
                        spaceBetween: 16,
                    },
                    1024: {
                        slidesPerView: 3.6,
                        slidesPerGroup: 1,
                        slidesPerGroupAuto: true,
                        spaceBetween: 32,
                    },
                },
            };
            if ($navLeft && $navRight) {
                swiperConfig.navigation = {
                    nextEl: $navRight,
                    prevEl: $navLeft,
                };
            }
            const swiperObject = new Swiper($wrapperSwiper, swiperConfig);
        }
    }
};

export default subscriptionPopular;